<template>
  <div>
    <iframe
      width="100%"
      height="1000px"
      :src="lookerUrl"
      frameborder="0"
      style="border: 0"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isNotCommonUser } from "@/constants/consultants";
import * as accountTypes from "@/modules/account/store/types";
import { isFeOrAboveRole } from "@/constants/auth";
export default {
  computed: {
    ...mapGetters({
      user: accountTypes.USER,
    }),
    lookerUrl(){
      if(isFeOrAboveRole(this.user?.user_role_id)){
        return `https://lookerstudio.google.com/embed/u/0/reporting/a6d2163c-54db-416a-be5a-8cbc18c3935c/page/ST7UF?params=%7B"df22":"include%25EE%2580%25801%25EE%2580%2580IN%25EE%2580%2580${this.user.digital_franchise_id}"%7D`
      }
      return `https://lookerstudio.google.com/embed/reporting/a6d2163c-54db-416a-be5a-8cbc18c3935c/page/ST7UF/edit?params=%7B%22df23%22:%22include%25EE%2580%25801%25EE%2580%2580IN%25EE%2580%2580${this.user.appify_consultant_id}%22%7D`
    }
  },
};
</script>
